import React from 'react';
import {
  Box,
  Flex,
  Image,
  Link,
  HStack,
  Text,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';

const Navbar = () => {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.50', 'gray.700');

  return (
    <Box
      as="nav"
      position="fixed"
      w="100%"
      top={0}
      zIndex={1000}
      bg={bgColor}
      borderBottom="1px"
      borderColor={borderColor}
      px={4}
      boxShadow="none"
    >
      <Flex
        h={20}
        alignItems="center"
        justifyContent="space-between"
        maxW="1200px"
        mx="auto"
        py={1}
      >
        {/* Logo */}
        <HStack spacing={4} alignItems="center">
          <Link href="https://deebits.com" isExternal>
            <Image
              src="/Deebits-Logo.png"
              alt="Deebits Software Engineering"
              height="90px"
              objectFit="contain"
            />
          </Link>
        </HStack>

        {/* Contact Links */}
        <HStack spacing={6}>
          <Text fontSize="lg" color="gray.600" display={{ base: 'none', md: 'block' }}>
            Canada: +1.672.514.1103
          </Text>
          <Button
            as={Link}
            href="https://deebits.com/index.php/contact/"
            target="_blank"
            rel="noopener noreferrer"
            colorScheme="deebits"
            size="lg"
            rightIcon={<ExternalLinkIcon />}
          >
            Contact Us
          </Button>
        </HStack>
      </Flex>
    </Box>
  );
};

export default Navbar; 